import {QueryCache, QueryClient} from '@tanstack/react-query';
import {showErrorMessage} from '../utils/messages';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            useErrorBoundary: true,
        },
    },
    queryCache: new QueryCache({
        onError: (error, query) => {
            if (!!error) {
                showErrorMessage(`Something went wrong: ${error}`);
            }
        },
    }),
});
